import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'


export default {
    install (Vue) {
        Vue.prototype.getPdf = function (domId, title) {
            return new Promise((rel) => {
				let w = document.querySelector(domId).clientWidth
				let h = document.querySelector(domId).scrollHeight
                console.log(w,h)
                html2Canvas(document.querySelector(domId), {
                    width: +w,
					height: +h,
					useCORS: true, //（图片跨域相关）
					allowTaint: true, //允许跨域
                }).then(function (canvas) {
                    console.log(canvas.width,canvas.height)
                    // return;
                    rel()
                    let contentWidth = canvas.width
                    let contentHeight = canvas.height
                    let pageHeight = contentWidth / 592.28 * 841.89  // a4纸的尺寸[592.28,841.89]
                    let leftHeight = contentHeight
                    let position = 0
                    let imgWidth = 595.28
                    let imgHeight = 592.28 / contentWidth * contentHeight
                    let pageData = canvas.toDataURL('image/jpeg', 1.0)
                    let PDF = new JsPDF('', 'pt', 'a4')
                    if (leftHeight < pageHeight) {
                        PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)  // 大于1页高度时分页
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                            leftHeight -= pageHeight
                            position -= 841.89
                            if (leftHeight > 0) {
                                PDF.addPage()
                            }
                        }
                    }
                    PDF.save(title + '.pdf')
                })
            })
        },
        /**
         * @function png图片导出，带分辨率
         * @dec 解决截图模糊问题方法，在源码中添加了两个参数，分别为 scale 和 dpi
         *      scale 是比例，按比例增加分辨率 (2=双倍)
         *      dpi 是指每英寸的像素，也就是扫描精度。
         *          dpi 越低，扫描的清晰度越低，由于受网络传输速度的影响，web 上使用的图片都是 72dpi，但是冲洗照片不能使用这个参数，必须是 300dpi 或者更高 350dpi。
         *          例如要冲洗 46 英寸的照片，扫描精度必须是 300dpi，那么文件尺寸应该是(4300)(6300)=1200 像素*1800 像素。
         *          只要增大 dpi 或者 scale 肯定能使同样宽高的图像变得清晰，那么模糊的问题也就不存在了。
         **/
         Vue.prototype.getPdfImg = function(ele) {
            let options = {
                width: ele.offsetWidth,
                height: ele.offsetHeight,
                logging: false,
                useCORS: true, //（图片跨域相关）
                background: '#ffffff',
                dpi: 300,
            };
            return new Promise((resolve) => {
                html2Canvas(ele, options).then(canvas => {
                    let url = canvas.toDataURL('image/png', 1.0); // 生成base64图片
                    resolve(url);
                });
            });
        };
        /**
         * @function a标签下载功能
         * @params {string} url 图片地址
         * @params {string} params 图片标题信息
         */
        Vue.prototype.downToA = function(url, picName) {
            const a = document.createElement('a');
            a.download = picName; // 图片名称
            a.setAttribute('href', url); // 下载
            a.click();
            a.remove();
        };
        Vue.prototype.domToBase64 = function (domId, height, cropY) {
            return new Promise((rel) => {
				let w = document.querySelector(domId).clientWidth
				let h = document.querySelector(domId).scrollHeight
                html2Canvas(document.querySelector(domId), {
                    width: +w,
					height,
                    y: cropY, // 从window顶部开始算。
					useCORS: true, //（图片跨域相关）
					allowTaint: true, //允许跨域
                }).then(function (canvas) {
                    let base64 = canvas.toDataURL('image/jpeg', 1.0)
                    rel(base64)
                })
            })
        };
        Vue.prototype.base64ToPdf = function(base64, title) {
            return new Promise((rel) => {
                const img = new Image()
                img.src = base64
                img.crossOrigin = 'Anonymous' // 跨域
                img.onload = () => {
                    let w = img.width
                    let h = img.height
                    let pageData = base64
                    let contentWidth = w
                    let contentHeight = h
                    let pageHeight = contentWidth / 592.28 * 841.89  // a4纸的尺寸[592.28,841.89]
                    let leftHeight = contentHeight
                    let position = 0
                    let imgWidth = 595.28
                    let imgHeight = 592.28 / contentWidth * contentHeight

                    let PDF = new JsPDF('', 'pt', 'a4')
                    if (leftHeight < pageHeight) {
                        PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)  // 大于1页高度时分页
                    } else {
                        while (leftHeight > 0) {
                            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
                            leftHeight -= pageHeight
                            position -= 841.89
                            if (leftHeight > 0) {
                                PDF.addPage()
                            }
                        }
                    }
                    PDF.save(title + '.pdf')
                }
            })
        };
    }
}